import axios from "axios";
import config from "./config";

export async function sendBessContactSales(
  token: string,
  body: { company_id: number; site_name?: string }
): Promise<void> {
  await axios.post(`${config.API_SERVICES}/api/v1/sdp/bess/contact-sales`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
